// Balança de mentira (dono, 26/10/2026: "nem tenho balança aqui pra gente
// fazer os testes"). Responde como uma balança de verdade: depois de mudar o
// peso, fica "instável" por um instante e então firma. Serve para treinar a
// equipe, demonstrar e para os testes do sistema. O peso é mexido pelo
// controle flutuante (SimuladorFlutuante.jsx).

const EVENTO = "nucleo:balanca-simulador";
const FIRMA_EM_MS = 700;

const estado = { kg: 0, mudouEm: 0 };

export function pesoSimulado() {
  return estado.kg;
}

export function colocarPeso(kg) {
  const novo = Math.max(0, Math.round((Number(kg) || 0) * 1000) / 1000);
  if (novo === estado.kg) return;
  estado.kg = novo;
  estado.mudouEm = Date.now();
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: novo }));
}

export function aoMudarSimulador(fn) {
  const h = (e) => fn(e.detail);
  window.addEventListener(EVENTO, h);
  return () => window.removeEventListener(EVENTO, h);
}

/** Mesma interface do cabo: pedir() devolve uma leitura. */
export const conexaoSimulada = {
  tipo: "simulador",
  async pedir() {
    await new Promise((r) => setTimeout(r, 60));
    if (Date.now() - estado.mudouEm < FIRMA_EM_MS) return { estado: "instavel", kg: null };
    if (estado.kg === 0) return { estado: "vazio", kg: 0 };
    return { estado: "ok", kg: estado.kg };
  },
  async fechar() {},
};
